/**
 * Care & Hanging drawer (sections/care-drawer.liquid): a native modal dialog shown as a side
 * drawer. Opens from any aria-controls="care-drawer" trigger; Esc, the close button and a
 * backdrop click close it, and focus returns to the trigger.
 */
import { defineElement } from '@wispaire/global';

class CareDrawer extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.onTrigger = (event) => {
      const trigger = event.target.closest?.(`[aria-controls="${this.dialog.id}"]`);
      if (!trigger) return;
      this.trigger = trigger;
      this.dialog.showModal();
    };
    document.addEventListener('click', this.onTrigger);
    this.dialog.addEventListener('close', () => this.trigger?.focus());
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog || event.target.closest('[data-close]')) this.dialog.close();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onTrigger);
  }
}

defineElement('care-drawer', CareDrawer);
